<template>
	<div>
		<div>
			<b-button @click="goBackToFrom" variant="outline-dark">
				<i class="fa fa-chevron-left"></i> {{ $t('back') }}
			</b-button>
			<b-button
				v-if="$route.params.action === 'edit'"
				style="position: absolute; right: 300px"
				@click="writeOffModalTrue"
				variant="warning"
			>
				{{ $t('spisat.title') }}
			</b-button>
			<b-button
				v-if="$route.params.action === 'edit'"
				style="position: absolute; right: 210px"
				@click="incomeModalTrue"
				variant="primary"
			>
				{{ $t('incomes.title') }}
			</b-button>
			<b-button v-if="$route.params.action === 'create'" style="position: absolute; right: 20px" variant="success" @click="saveInventory">
				{{ $t('save-finish') }}
			</b-button>
			<b-button v-else-if="$route.params.action === 'edit'" style="position: absolute; right: 20px" variant="success" @click="saveEditingInventory">
				{{ $t('save-finish') }}
			</b-button>
		</div>
		<b-card class="mt-2">
			<div slot="header" class="d-flex justify-content-between custom-card-header">
				<span class="card-header-title">{{ $t('inventory.newInventory') }}</span>
				<div class="card-header-actions">
					<div class="searchInCard">
						<b-input-group size="sm">
							<b-form-input
								v-model="search"
								size="sm"
								:placeholder="$t('contragent.filter')"
								autocomplete="off"/>
							<b-input-group-append>
								<b-button :disabled="!search" @click="search = ''">
									{{ $t('contragent.clear') }}
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</div>
				</div>
			</div>
			<div v-if="$route.params.action === 'create'">
				<b-row>
					<b-col>
						<multiselect
							v-model="depId"
							:options="departments"
							:multiple="false"
							trackBy="id"
							:show-labels="false"
							:allow-empty="true"
							label="name"
							:placeholder="$t('promo-to-product.department')"
							class="multiselect-pricing"
						/>
					</b-col>
					<b-col>
						<multiselect
							v-model="employee"
							:options="employees"
							:multiple="true"
							track-by="id"
							:show-labels="false"
							:allow-empty="true"
							label="firstName"
							@search-change="fetchEmployees($event)"
							:placeholder="$t('incomes.create.responsible')"
							class="multiselect-pricing"
						/>
					</b-col>
					<b-col>
						<b-form-textarea
							:placeholder="$t('incomes.reason')"
							v-model="reason"
							rows="2"
						/>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b-tabs v-model="activeTab">
							<b-tab v-for="item in employee" :title="item.firstName">
								<b-row>
									<b-col>
										<b-form-group
											breakpoint="lg"
											label-cols="3"
											label-for="refName"
											class="required ml-1"
										>
											<template slot="label">
												{{ $t('goods.create.select-group') }}:
											</template>
											<multiselect
												v-model="item.subCategoryId"
												:options="subCategory_s"
												:label="`name`"
												track-by="id"
												@remove="item.subCategoryId = null"
												@select="selectedGroup"
												:show-labels="false"
												:allow-empty="true"
												:placeholder="$t('goods.create.select-group')"
												class="multiselect-pricing h"
											></multiselect>
										</b-form-group>
									</b-col>
									<b-col>
										<b-form-group
											breakpoint="lg"
											label-cols="3"
											label-for="refName"
											class="required ml-1"
										>
											<template slot="label">
												{{ $t('goods.create.category') }}:
											</template>
											<multiselect
												v-model="item.subCategory1Id"
												:options="subCategory1_s"
												:disabled="!item.subCategoryId"
												:label="`name`"
												track-by="id"
												@remove="item.subCategory1Id = null"
												@select="selectedCategory"
												:show-labels="false"
												:allow-empty="true"
												:placeholder="$t('goods.create.category')"
												class="multiselect-pricing h"
											></multiselect>
										</b-form-group>
									</b-col>
									<b-col>
										<b-form-group
											breakpoint="lg"
											label-cols="3"
											label-for="refName"
											class="required ml-1"
										>
											<template slot="label">
												{{ $t('goods.create.select-subcategory') }}:
											</template>
											<multiselect
												v-model="item.subCategory2Id"
												:options="subCategory2_s"
												:disabled="!item.subCategory1Id"
												:label="`name`"
												track-by="id"
												@remove="item.subCategory2Id = null"
												@select="selectedSubCategory"
												:show-labels="false"
												:allow-empty="true"
												:placeholder="$t('goods.create.select-subcategory')"
												class="multiselect-pricing h"
											></multiselect>
										</b-form-group>
									</b-col>
									<b-col cols="1">
										<b-btn class="fa fa-search" pill variant="dark" @click="$route.params.action === 'create' ? getItems() : editingGetItems()"/>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-table
											:items="items.items"
											:fields="fields"
											:busy="loading"
											:per-page="0"
											show-empty
											responsive
											striped
											hover
											bordered
										>
											<template slot="index" slot-scope="data">
												{{ paginate(data.index, payload.page, payload.limit) }}
											</template>
											<template slot="multiBarcode" slot-scope="data">
												<h6>
													<b-badge v-for="barcode in data.item.multiBarcode" class="ml-2">
														{{ barcode }}
													</b-badge>
												</h6>
											</template>
											<template slot="remaining" slot-scope="data">
												{{ data.item.remaining + ' ' + data.item.unitName }}
											</template>
											<template #table-busy>
												<div class="text-center text-primary my-2">
													<b-spinner class="align-middle mr-2"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
										</b-table>
										<nav>
											<b-pagination
												:total-rows="items.total"
												:per-page="payload.limit"
												v-model="payload.page"
												:disabled="loading"
												aria-controls="table"/>
										</nav>
									</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-col>
				</b-row>
			</div>
			<div v-else>
				<b-row>
					<b-col>
						<h5 class="card-header-title">{{ $t('incomes.name') }}: </h5>
						<span>{{ editingDoc.inventoryNumber }}</span>
					</b-col>
					<b-col>
						<h5 class="card-header-title">{{ $t('inventory.startDate') }}: </h5>
						<span>{{ editingDoc.startDate }}</span>
					</b-col>
					<b-col>
						<h5 class="card-header-title">{{ $t('incomes.department') }}: </h5>
						<span>{{ editingDoc.departmentName }}</span>
					</b-col>
					<b-col>
						<h5 class="card-header-title">{{ $t('incomes.reason') }}: </h5>
						<span>{{ editingDoc.description }}</span>
					</b-col>
				</b-row>
				<b-row v-if="$can('inventory', 'manager') && incomeDoc.incomeRegNumber!='null' && incomeDoc.incomeReason!='null'" style="cursor: pointer" class="mt-2">
					<b-col><b>{{ incomeDoc.incomeRegNumber }}</b> - {{ incomeDoc.incomeReason }}</b-col>
					<b-col><b-button @click="$router.push(`/warehouse-management/income-view/view/${incomeDoc.whDocumentId}`)" variant="primary" class="fa fa-eye"/></b-col>
				</b-row>
				<b-row v-if="$can('inventory', 'manager') && writeOffDoc.incomeRegNumber!='null' && writeOffDoc.incomeReason!='null'"  style="cursor: pointer" class="mt-2">
					<b-col><b>{{ writeOffDoc.incomeRegNumber }}</b> - {{ writeOffDoc.incomeReason }}</b-col>
					<b-col><b-button @click="$router.push(`/warehouse-management/writeOff/view/${writeOffDoc.whDocumentId}`)" variant="primary" class="fa fa-eye"/></b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b-tabs v-model="editingActiveTab">
							<b-tab v-for="item in editingDoc.employees" :title="item.employeeName">
								<b-row class="mt-2">
									<b-col>
										<h5 class="card-header-title">{{ $t('goods.create.select-group') }}: </h5>
										<span>{{ item.subCategoryName }}</span>
									</b-col>
									<b-col>
										<h5 class="card-header-title">{{ $t('goods.create.category') }}: </h5>
										<span>{{ item.sub2CategoryName }}</span>
									</b-col>
									<b-col>
										<h5 class="card-header-title">{{ $t('goods.create.select-subcategory') }}: </h5>
										<span>{{ item.sub3CategoryName }}</span>
									</b-col>
									<b-col v-if="$route.params.action === 'edit'" cols="1" align="right">
										<b-btn v-if="item.hasFinished" variant="success"
											   @click="toRecount('check', item)">
											<i class="fa fa-check" style="font-size: 15px"/>
										</b-btn>
										<b-btn v-else variant="danger" @click="toRecount('close', item)">
											<i class="fa fa-close" style="font-size: 15px"/>
										</b-btn>
									</b-col>
								</b-row>
								<b-row class="mt-3">
									<b-col>
										<b-table
											:items="editingItems.items"
											:fields="editingFields"
											:busy="loading"
											:per-page="0"
											show-empty
											responsive
											striped
											hover
											bordered
										>
											<template slot="index" slot-scope="data">
												{{ paginate(data.index, editingPayload.page, editingPayload.limit) }}
											</template>
											<template slot="multiBarcode" slot-scope="data">
												<span v-for="barcode in data.item.multiBarcode">{{ barcode }}<br></span>
											</template>
											<template slot="difference" slot-scope="data">
												{{ data.item.difference }}
											</template>
											<template #table-busy>
												<div class="text-center text-primary my-2">
													<b-spinner class="align-middle mr-2"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
										</b-table>
										<nav style="display: inline-block">
											<b-pagination
												:total-rows="editingItems.total"
												:per-page="editingPayload.limit"
												v-model="editingPayload.page"
												:disabled="loading"
												aria-controls="table"/>
										</nav>
										<b-form-select v-model="editingPayload.limit" :options="limits" style="width: 100px; display: inline-block; left: 0"/>
									</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-col>
				</b-row>
				<b-modal
					v-model="incomeModal"
					:title="$t('incomes.title')"
					size="xl"
					centered
					hide-footer
					no-close-on-backdrop
					@close="incomeModalTrue"
				>
					<b-table
						:items="incomeItems"
						:fields="editingFields"
						:busy="loadingModal"
						:per-page="0"
						show-empty
						responsive
						striped
						hover
						bordered
					>
						<template slot="index" slot-scope="data">
							{{ data.index + 1 }}
						</template>
						<template slot="multiBarcode" slot-scope="data">
							<span v-for="barcode in data.item.multiBarcode">{{ barcode }}<br></span>
						</template>
						<template #table-busy>
							<div class="text-center text-primary my-2">
								<b-spinner class="align-middle mr-2"></b-spinner>
								<strong>Loading...</strong>
							</div>
						</template>
					</b-table>
					<b-row>
						<b-col align="right">
							<b-btn variant="danger" class="mr-3" @click="incomeModal = false">
								{{ $t('actions.cancel') }}
							</b-btn>
							<b-btn variant="success" @click="incomesInventoryDoc">
								{{ $t('incomes.title') }}
							</b-btn>
						</b-col>
					</b-row>
				</b-modal>
				<b-modal
					v-model="writeOffModal"
					:title="$t('spisat.title')"
					size="xl"
					centered
					hide-footer
					no-close-on-backdrop
				>
					<b-table
						:items="writeOffItems"
						:fields="editingFields"
						:busy="loadingModal"
						:per-page="0"
						show-empty
						responsive
						striped
						hover
						bordered
					>
						<template slot="index" slot-scope="data">
							{{ data.index + 1 }}
						</template>
						<template slot="multiBarcode" slot-scope="data">
							<span v-for="barcode in data.item.multiBarcode">{{ barcode }}<br></span>
						</template>
						<template #table-busy>
							<div class="text-center text-primary my-2">
								<b-spinner class="align-middle mr-2"></b-spinner>
								<strong>Loading...</strong>
							</div>
						</template>
					</b-table>
					<b-row>
						<b-col align="right">
							<b-btn variant="danger" class="mr-3" @click="writeOffModal = false">
								{{ $t('actions.cancel') }}
							</b-btn>
							<b-btn variant="success" @click="writeOffInventoryDoc">{{ $t('spisat.title') }}</b-btn>
						</b-col>
					</b-row>
				</b-modal>
			</div>
		</b-card>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import UsersService from "../../../services/users.sevice";
import EmployeesService from "../../../services/employees.service";
import ReferencesService from "../../../services/references.sevice";
import InventoryService from "./inventory.service";

export default {
	name: "CreateOrUpdate",
	data() {
		return {
			search: '',
			payload: {
				page: 1,
				limit: 20,
				value: ''
			},
			editingPayload: {
				page: 1,
				limit: 20,
				value: ''
			},
			limits: [20, 50, 100, 200, this.editingItems ? this.editingItems.total : ''],
			activeTab: null,
			editingActiveTab: null,
			depId: null,
			departmentId: null,
			departments: [],
			employee: [],
			loading: false,
			loadingModal: false,
			employees: [],
			employeeIds: [],
			reason: '',
			subCategory_s: [],
			subCategoryId: null,
			subCategory1_s: [],
			subCategory1Id: null,
			subCategory2_s: [],
			subCategory2Id: null,
			items: [],
			editingItems: [],
			incomeItems: [],
			writeOffItems: [],
			editingDoc: {},
			incomeDoc: {},
			writeOffDoc: {},
			incomeModal: false,
			writeOffModal: false,
			fields: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'itemName', label: this.$t('pos.product')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center'},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'remaining', label: 'Oстатка', class: 'text-center'}
			],
			editingFields: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'itemName', label: this.$t('pos.product')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center'},
				{key: 'inventory', label: 'Oстатка', class: 'text-center'},
				{key: 'count', label: this.$t('incomes.create.count'), class: 'text-center'},
				{key: 'difference', label: 'Разница', class: 'text-center'}
			]
		}
	},
	components: {Multiselect},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		goBackToFrom() {
			this.$router.back();
		},
		fetchEmployees($event) {
			EmployeesService.searchEmployee($event).then(res => {
				this.employees = res.data
			})
		},
		getEmployees(depId) {
			EmployeesService.getEmployeeIfHaveLogin(depId).then(response => {
				if (response.data) {
					this.employees = response.data;
				} else {
					this.employee = null
					this.employees = []
				}
			})
		},
		selectedGroup($event) {
			this.subCategory1Id = null
			this.subCategory2Id = null
			this.subCategoryId = $event.id
			ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory1_s = res.data
			})
		},
		selectedCategory($event) {
			this.subCategory2Id = null
			this.sub2CategoryId = $event.id
			ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory2_s = res.data
			})
		},
		selectedSubCategory($event) {
			this.sub3CategoryId = $event.id
		},
		editingGetItems() {
			this.loading = true
			if (!this.editingActiveTab || this.editingActiveTab === -1) {
				this.editingActiveTab = 0
			}
			this.editingPayload.employeeId = this.editingDoc.employees[this.editingActiveTab].employeeId
			this.editingPayload.value = this.search
			InventoryService.getInventoryItems(this.editingPayload, this.$route.params.docId).then(res => {
				this.editingItems = res.data
				this.loading = false
			})
		},
		getItems() {
			this.loading = true
			this.employee.forEach((em, index) => {
				if (this.activeTab === index) {
					this.payload.subCategoryId = em.subCategoryId ? em.subCategoryId.id : null
					this.payload.sub2CategoryId = em.subCategory1Id ? em.subCategory1Id.id : null
					this.payload.sub3CategoryId = em.subCategory2Id ? em.subCategory2Id.id : null
					this.payload.departmentId = this.departmentId
				}
			})
			this.payload.value = this.search
			InventoryService.getItems(this.payload).then(res => {
				this.items = res.data
				this.loading = false
			})
		},
		saveInventory() {
			let data = {
				departmentId: this.departmentId,
				description: this.reason,
				responsible: []
			}
			this.employee.forEach(em => {
				let o = {
					responsibleId: em.id,
					subCategoryId: em.subCategoryId ? em.subCategoryId.id : null,
					sub2CategoryId: em.subCategory1Id ? em.subCategory1Id.id : null,
					sub3CategoryId: em.subCategory2Id ? em.subCategory2Id.id : null
				}
				data.responsible.push(o)
			})
			this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
				hideHeader: true,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: this.$t('actions.yes'),
				cancelTitle: this.$t('actions.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					this.loading = true
					InventoryService.saveInventory(data).then(res => {
						this.goBackToFrom();
						this.loading = false
						this.$vs.notify({
							text: 'Документ успешно сохранен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					})
				}
			})
		},
		saveEditingInventory() {
			this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
				hideHeader: true,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: this.$t('actions.yes'),
				cancelTitle: this.$t('actions.no'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value) {
					InventoryService.toRecount(this.$route.params.docId, 'FINISH').then(res => {
						this.goBackToFrom();
						this.$vs.notify({
							text: 'Документ успешно сохранен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					})
				}
			})
		},
		incomeModalTrue() {
			this.incomeModal = true
			this.loadingModal = true
			InventoryService.getInventoryItemsByAction(this.$route.params.docId, 'INCOME').then(res => {
				this.incomeItems = res.data
				this.loadingModal = false
			})
		},
		writeOffModalTrue() {
			this.writeOffModal = true
			this.loadingModal = true
			InventoryService.getInventoryItemsByAction(this.$route.params.docId, 'WRITE-OFF').then(res => {
				this.writeOffItems = res.data
				this.loadingModal = false
			})
		},
		incomesInventoryDoc() {
			InventoryService.incomesInventoryDoc(this.$route.params.docId).then(res => {
				this.incomeModal = false
				this.$vs.notify({
					text: 'Документ успешно сохранен',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		writeOffInventoryDoc() {
			InventoryService.writeOffInventoryDoc(this.$route.params.docId).then(res => {
				this.writeOffModal = false
				this.$vs.notify({
					text: 'Документ успешно сохранен',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		toRecount(action, item) {
			if (action === 'check') {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						InventoryService.toRecount(item.inventoryId, 'RECOUNT').then(res => {
							item.hasFinished = false
						})
					}
				})
			} else {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						InventoryService.toRecount(item.inventoryId, 'FINISH').then(res => {
							item.hasFinished = true
						})
					}
				})
			}
		}
	},
	watch: {
		'depId': {
			handler(event) {
				if (event) {
					this.departmentId = event.id
					this.getEmployees(event.id)
					this.employees = []
					this.employee = null

				} else {
					this.employee = null
					this.employees = []
					this.departmentId = null
				}
			}
		},
		'payload.page': {
			handler(res) {
				this.getItems();
			}
		},
		'editingPayload.page': {
			handler(res) {
				this.editingGetItems();
			}
		},
		'editingPayload.limit': {
			handler(res) {
				this.editingGetItems();
			}
		},
		'search': {
			handler(res) {
				if (this.$route.params.action === 'create') {
					this.getItems();
				} else {
					this.editingGetItems();
				}
			}
		},
		'editingActiveTab': {
			handler(res) {
				this.editingPayload.page = 1
				this.editingGetItems();
			}
		},
		'activeTab': {
			handler(res) {
				this.employee.forEach((em, index) => {
					if (this.activeTab === index) {
						if (em.subCategoryId) {
							this.getItems();
						} else {
							this.items = []
						}
					}
				})
			}
		}
	},
	async created() {
		if (this.$route.params.action === 'create') {
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			ReferencesService.getSubReferenceChildren(14).then(res => {
				this.subCategory_s = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		} else {
			await InventoryService.getInventoryDoc(this.$route.params.docId).then(res => {
				this.editingDoc = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await InventoryService.getIncomeDoc(this.$route.params.docId).then(res => {
				this.incomeDoc = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await InventoryService.getWriteOffDoc(this.$route.params.docId).then(res => {
				this.writeOffDoc = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await this.editingGetItems();
		}
	}
}
</script>

<style scoped>

</style>
